import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleISO27001PMEAccessible() {
  return (
    <BlogArticleLayout
      tag="ISO 27001"
      title="ISO 27001 pour les PME : est-ce accessible sans grosse structure ?"
      date="8 octobre 2026"
      ctaTitle="Situez votre PME par rapport à ISO 27001"
      ctaText="Le diagnostic évalue vos pratiques actuelles au regard des exigences ISO 27001, sans jargon ni engagement de certification."
    >
      <p style={s.intro}>
        ISO 27001 a la réputation d'être réservée aux grandes entreprises, avec des mois de préparation et une
        montagne de documentation. Cette réputation est en grande partie exagérée : la norme est conçue pour
        être proportionnée à la taille et à la complexité de l'organisation qui l'applique.
      </p>

      <h2 style={s.h2}>Ce que la norme demande réellement</h2>
      <p>
        ISO 27001 ne fixe pas une liste universelle de mesures techniques obligatoires. Elle demande de mettre
        en place un système de management de la sécurité de l'information (SMSI) : une démarche structurée
        pour identifier vos risques, décider comment les traiter, et suivre l'efficacité de ces décisions dans
        le temps. Pour une PME, ce SMSI peut rester simple et proportionné à son activité réelle.
      </p>

      <h2 style={s.h2}>Les étapes, simplifiées pour une PME</h2>
      <ul style={s.ul}>
        <li style={s.li}>Définir le périmètre couvert (l'ensemble de l'entreprise, ou seulement certaines activités).</li>
        <li style={s.li}>
          Identifier et évaluer vos risques, en s'appuyant sur la même logique que décrite dans notre article
          {' '}<Link to="/blog/gestion-des-risques-cybersecurite-methode-commune" style={s.link}>sur la gestion des risques</Link>.
        </li>
        <li style={s.li}>Choisir et mettre en place les mesures de sécurité adaptées à ces risques.</li>
        <li style={s.li}>Documenter vos décisions et procédures, sans viser l'exhaustivité bureaucratique.</li>
        <li style={s.li}>Suivre et réviser régulièrement l'ensemble, plutôt que de le figer une fois pour toutes.</li>
      </ul>

      <h2 style={s.h2}>Certification ou simple référence : deux usages différents</h2>
      <p>
        Vous n'êtes pas obligé de viser la certification officielle dès le départ. Beaucoup de PME s'inspirent
        d'abord de la structure ISO 27001 pour organiser leur sécurité, sans passer par un audit de
        certification externe — utile pour progresser en interne. La certification formelle devient pertinente
        quand un client, un appel d'offres ou un partenaire l'exige explicitement.
      </p>

      <h2 style={s.h2}>Le temps et l'investissement réalistes pour une PME</h2>
      <p>
        Pour une petite structure avec un périmètre limité et déjà quelques bonnes pratiques en place, viser
        une première version d'un SMSI simplifié se compte en semaines, pas en années. La difficulté n'est
        généralement pas le volume de travail, mais l'absence de méthode pour démarrer — d'où l'intérêt de
        partir d'un diagnostic qui identifie déjà vos écarts plutôt que de repartir de zéro.
      </p>

      <h2 style={s.h2}>ISO 27001 face au RGPD et à NIS2</h2>
      <p>
        Contrairement au RGPD et à NIS2, ISO 27001 reste une démarche volontaire — voir notre article
        {' '}<Link to="/blog/rgpd-nis2-iso27001-differences" style={s.link}>RGPD, NIS2, ISO 27001 : quelles différences ?</Link>{' '}
        pour resituer les trois référentiels. Mais les mesures qu'elle structure recoupent largement les
        obligations des deux autres : progresser sur l'une facilite généralement les deux autres.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleISO27001PMEAccessible;
